<template>
  <div class="sec-card">
    <h3>{{ title }}</h3>
    <div v-if="hint" class="sec-hint">{{ hint }}</div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "SectionCard",
  props: {
    title: { type: String, required: true },
    hint: { type: String, default: "" },
  },
};
</script>

<style scoped>
.sec-card {
  background: var(--nd-card);
  border: 1px solid var(--nd-border);
  border-radius: 14px;
  padding: 20px;
  box-shadow: var(--nd-shadow);
}
.sec-card h3 {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.01em;
  margin: 0;
}
.sec-hint {
  font-size: 12px;
  color: var(--nd-muted);
  margin: 3px 0 16px;
  line-height: 1.45;
}
</style>
